export default __webpack_public_path__ + "static/media/hero-level-2-chars-desk.e669937a.webp";